var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu,-Category",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-25.000000, -429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(25.000000, 429.000000)",
    fill: "#003755"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.17342105,0.848421053 C0.994671053,0.848421053 0.849276316,0.993815789 0.849276316,1.17256579 L0.849276316,24.5323684 C0.849276316,24.7111184 0.994671053,24.8565132 1.17342105,24.8565132 L24.3972368,24.8565132 C24.5759868,24.8565132 24.7222368,24.7111184 24.7222368,24.5323684 L24.7222368,1.17256579 C24.7222368,0.993815789 24.5759868,0.848421053 24.3972368,0.848421053 L1.17342105,0.848421053 Z M24.3972368,25.7049342 L1.17342105,25.7049342 C0.526842105,25.7049342 0,25.1789474 0,24.5323684 L0,1.17256579 C0,0.525986842 0.526842105,0 1.17342105,0 L24.3972368,0 C25.0446711,0 25.5706579,0.525986842 25.5706579,1.17256579 L25.5706579,24.5323684 C25.5706579,25.1789474 25.0446711,25.7049342 24.3972368,25.7049342 Z",
    id: "Combined-shape-Copy",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "youtube-youtube-path",
    points: "7 19.478684 19 13.2611201 7 7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.699bd732afba09fa5777c12b3df0de51.svg";
export { ForwardRef as ReactComponent };